export default __webpack_public_path__ + "static/media/cart-04-PT.3dee65fd.jpg";